// extracted by mini-css-extract-plugin
export default {"InfiniteEndMessage":"InfiniteEndMessage_InfiniteEndMessage__I0Ec4","seperator":"InfiniteEndMessage_seperator__ywz2W","infinite_text":"InfiniteEndMessage_infinite_text__qVdg1"};